import React, { useState, FC, useEffect } from 'react';

export interface ClientSideProps {
    clientSide: boolean;
}

export const withClientSideRender = <T extends ClientSideProps>(Component: FC<T>) => {
    const WrappedComponent = (props: T) => {
        const [isMounted, setIsMounted] = useState(false);

        useEffect(() => {
            setIsMounted(true);
        }, []);

        if (props.clientSide && !isMounted) return null;

        return <Component {...props} />;
    };

    WrappedComponent.displayName = 'withClientSideRender';

    return WrappedComponent;
};
